import { WearableSensorStatus } from "@/api/SensorsService"
import { IconProps } from "@/components/shared/Icon"

export function getWearableStatusIcon(
   status: WearableSensorStatus
): IconProps["name"] {
   switch (status) {
      case WearableSensorStatus.CHARGING:
         return "batteryCharging"
      case WearableSensorStatus.IDLE:
         return "clock"
      default:
         return "smartwatch"
   }
}
